export const JIRA_COMPLETION_COLUMN_COPY = {
  section: "When SuperPlane completes the task",
  move: "Move the Jira issue to this column",
  column: "Column",
  helper: "SuperPlane moves the issue here when the task completes.",
  loading: "Loading columns...",
  empty: "This project has no columns SuperPlane can move the issue to.",
} as const;
